import { Scopes, useScopes } from '../../auth/scopes';
const useHasCPQScope = () => {
  const scopes = useScopes();
  return scopes.has(Scopes.cpqQuoteAccess);
};
export default useHasCPQScope;